import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { ModalController, NavParams, ToastController } from "@ionic/angular";
import { ViewPdfComponent } from "../../view-pdf/view-pdf.component";
import { InvoiceSaveModel } from "src/app/model/InvoiceSaveModel";
import { MasterService } from "src/app/services/master.service";

@Component({
  selector: "app-secure-invoice-settlement",
  templateUrl: "./invoice-settlement.html",
})
export class invoiceSettlementModal implements OnInit {
  settlememntForm: FormGroup = new FormGroup({});
  pan: string;
  applicantName: string;
  selectedFile: File;
  orderDocumentFile: string | ArrayBuffer;
  orderDocumentFileFOrView: string | ArrayBuffer;
  orderDocument: string;
  orderFile: string;
  isLoading: boolean = false;
  invoiceNo:string;
  showOrderDocFile: string;
  invoiceSettleFile: boolean = false;


  constructor(
    private modalCtrl: ModalController,
    private masterService: MasterService,
    private toastController: ToastController,
    private _snackBar: MatSnackBar,
    private navParams: NavParams,
    private fb: FormBuilder, 
  ) {}

  ngOnInit(): void {

    this.invoiceNo = this.navParams.get('invoiceNo');

    this.settlememntForm = new FormGroup({
      receivedAmount: new FormControl(null, Validators.required),
      deductionAmount: new FormControl(null, Validators.required),
      gstAmount: new FormControl(null, Validators.required),
      file2: new FormControl(null)
    });
  }

  async showErrorToast(errorMessage: string) {
    const toast = await this.toastController.create({
      message: errorMessage,
      icon: "information-circle",
      position: "top",
      duration: 2000,
    });
    toast.present();
  }

  async ngSubmit() {}
  handleKeyPress(event: KeyboardEvent): void {
    const textarea = event.target as HTMLTextAreaElement;
    const cursorPosition = textarea.selectionStart;
    if (cursorPosition === 0 && event.key === " ") {
      event.preventDefault();
    }
  }

  onOrderFileSelect(event) {
    const file = event.target.files[0];
    if (!file) {
      this.selectedFile=null;
      this._snackBar.open("No file selected.", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: 3000,
      });
      return;
    }
    
    if (file.size < 2 * 1024 * 1024) {
      this.selectedFile = file;
      if (this.selectedFile && this.selectedFile.type === "application/pdf") {
        console.log("this.selectedFile", this.selectedFile);
        const reader = new FileReader();
        reader.readAsDataURL(this.selectedFile);
        reader.onload = () => {
          this.orderDocumentFile = reader.result;
          this.orderDocumentFileFOrView = this.orderDocumentFile;
          const fileNameParts = this.selectedFile.name.split(".");
          this.orderFile = this.selectedFile.name;
          const fileNameWithoutExtension = fileNameParts[0];
          this.orderDocument = fileNameWithoutExtension;
          // this.previewDocumentfile(this.orderDocumentFile);
          console.log("reader 1", reader.result);
        };
        console.log("reader 2", reader.result);

      } else {
        this.selectedFile = null;
        this.orderDocumentFile = null;
        this._snackBar.open("Please select a valid PDF file.", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "error-toast",
          duration: 3 * 1000,
        });
      }
    } else {
      this.selectedFile = null;
      this.orderDocumentFile = null;
      this._snackBar.open("File size exceeds 2MB.", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: 3 * 1000,
      });
    }
  }

  openPreviewOtherDocumentFile() {
    this.PreviewOtherDocumentfile(this.orderDocumentFileFOrView);
  }

  async PreviewOtherDocumentfile(base64) {
    this.isLoading = true;
    this.isLoading = false;
    const base64Data = base64.split(",")[1];
    const modal = await this.modalCtrl.create({
      component: ViewPdfComponent,
      componentProps: {
        base64: base64Data,
        documentName: "Order Letter",
        fileName:
          "INVOICE_FILE_" +
          this.invoiceNo +
          "_" +
          new Date().getTime() +
          ".pdf",
      },
    });
    modal.present();
  }

  approve() {
    const receivedAmount = this.settlememntForm.value.receivedAmount;
    const deductionAmount = this.settlememntForm.value.deductionAmount;
    const gstAmount = this.settlememntForm.value.gstAmount;
    const file= this.selectedFile;

    console.log("Received Amount:", receivedAmount);
    console.log("Deduction Amount:", deductionAmount);
    console.log("GST Amount:", gstAmount);

    if (!this.settlememntForm.value.receivedAmount) {
      this.showErrorToast("Please Enter Received Amount");
      return;
    } else if (!this.settlememntForm.value.deductionAmount) {
      this.showErrorToast("Please Enter deduction Amount");
      return;
    } else if (!this.settlememntForm.value.gstAmount) {
      this.showErrorToast("Please Enter GST Amount");
      return;
    }
    else if (!file) {
      this.showErrorToast("Please upload file");
      return;
    }
    else if (file) {
      this.invoiceNo = this.navParams.get('invoiceNo');
      console.log("INVOICE_NO+++++++++++++++++",this.invoiceNo )
      const invoiceData: InvoiceSaveModel = {
        invoiceNo: this.invoiceNo,
        orderFile: this.orderFile,
        orderDocumentFile: this.orderDocumentFile,
        receivedAmount: receivedAmount,
        deductionAmount: deductionAmount,
        gstAmount: gstAmount,
        approve: "APPROVED",
      };
      
      console.log("++++++++++++++invoiceData = ",invoiceData);

      this.masterService.saveSettledInvoice(invoiceData).subscribe(
        (data) => {
          console.log(data, "fromStatus files API");
          this._snackBar.open("Invoice Settled", "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "success-toast",
            duration: 3000,
          });
          // this.onLoad();
          return this.modalCtrl.dismiss(
            this.settlememntForm.value.approveReason,
            "approve"
          );
        },
        (error) => {
          console.error("Error saving invoice:", error);
          this.showErrorToast("Failed to save invoice. Please try again.");
        }
      );
    }
  }
  // this.masterService
  //       .saveSettledInvoice({
  //         invoiceNo: this.invoiceNo,
  //         orderFile: this.orderFile,
  //         orderDocumentFile: this.orderDocumentFile,
  //         receivedAmount: this.receivedAmount,
  //         deductionAmount: this.deductionAmount,
  //         gstAmount: this.gstAmount,
  //         approve: "APPROVED",
  //       })
  //       .subscribe((data) => {
  //         console.log(data, "fromStatus files API");
  //         this.onLoad();
  //         this._snackBar.open("Invoice Settled", "Close", {
  //           horizontalPosition: "right",
  //           verticalPosition: "top",
  //           panelClass: "success-toast",
  //           duration: 3 * 1000,
  //         });
  //       });

  cancel() {
    return this.modalCtrl.dismiss(null, "cancel");
  }
}
